import React, { useCallback, useRef } from 'react';
import { clampAiWidth } from './aiPanelWidth';

interface Props {
  /** Одоогийн өргөн (px) — гараар өөрчлөөгүй бол самбарын бодит өргөн. */
  getWidth: () => number;
  onResize: (width: number) => void;
  /** Давхар дарахад үндсэн өргөн рүү буцна. */
  onReset: () => void;
}

/**
 * AI туслахын зүүн ирмэг — чирж өргөсгөнө / нарийсгана.
 * Самбар цонхны баруун захад байгаа тул өргөн = цонхны өргөн − заагчийн X.
 */
const AiPanelResizer: React.FC<Props> = ({ getWidth, onResize, onReset }) => {
  const dragging = useRef(false);

  const onPointerDown = useCallback((e: React.PointerEvent<HTMLDivElement>) => {
    e.preventDefault();
    dragging.current = true;
    e.currentTarget.setPointerCapture(e.pointerId);
    document.body.classList.add('ai-panel-resizing');
  }, []);

  const onPointerMove = useCallback((e: React.PointerEvent<HTMLDivElement>) => {
    if (!dragging.current) return;
    onResize(clampAiWidth(window.innerWidth - e.clientX));
  }, [onResize]);

  const stop = useCallback((e: React.PointerEvent<HTMLDivElement>) => {
    if (!dragging.current) return;
    dragging.current = false;
    e.currentTarget.releasePointerCapture(e.pointerId);
    document.body.classList.remove('ai-panel-resizing');
  }, []);

  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const step = e.shiftKey ? 80 : 20;
    if (e.key === 'ArrowLeft') { e.preventDefault(); onResize(clampAiWidth(getWidth() + step)); }
    if (e.key === 'ArrowRight') { e.preventDefault(); onResize(clampAiWidth(getWidth() - step)); }
  };

  return (
    <div
      className="app-ai-resizer"
      role="separator"
      aria-orientation="vertical"
      aria-label="AI туслахын өргөн"
      tabIndex={0}
      title="Чирж өргөсгөх · давхар дарж анхны хэмжээнд"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stop}
      onPointerCancel={stop}
      onDoubleClick={onReset}
      onKeyDown={onKeyDown}
    />
  );
};

export default AiPanelResizer;
